import { Theme } from '@mui/material';
import { Colors } from '../../../utils/theme';

export const headerStyles = (theme: Theme) => ({
	root: {
		position: 'sticky',
		left: 0,
		right: 0,
		zIndex: 1000,
		width: '100%',

		display: 'flex',
		flexDirection: 'column',

		borderBottom: `2px solid ${Colors['120E0D']}`,
		backgroundColor: '#fff',
		overflow: 'auto',
	},
	row: {
		display: 'flex',
		flexDirection: 'row',
		alignItems: 'center',
		py: 2,
		px: 4,
		gap: { xs: '20px', md: '30px', lg: '40px' },
	},
});
